/* ACC_CusbClo_Product_87: Solo / Bundle selector on the PDP.
   Markup, targeting and the matching item come from snippets/acc_cusbclo_product_87.liquid.
   This script only does what Liquid cannot:
   - keeps the bundle size select and the theme size picker in sync
   - updates the Solo / Bundle prices when a size changes
   - in Bundle mode, adds both items to the cart with the bundle properties
   The block is revealed only after setup succeeds, so the normal PDP keeps working if anything here fails. */
(() => {
  const LOG_PREFIX = '[ACC_CusbClo_Product_87]';

  const formatMoney = (cents) => {
    if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return null;
  };

  const setup = (root) => {
    if (root.dataset.accReady) return;

    const scope = root.closest('[data-product-blocks]') || document;
    const form = document.getElementById(root.dataset.formId) || scope.querySelector('form[action*="/cart/add"]');
    const currentSelect = root.querySelector('[data-size-current]');
    const secondSelect = root.querySelector('[data-size-second]');
    const duoInput = root.querySelector('input[value="duo"]');
    const soloPriceEl = root.querySelector('[data-solo-price]');
    const duoPriceEl = root.querySelector('[data-duo-price]');
    if (!form || !currentSelect || !secondSelect || !duoInput) throw new Error('Missing form or bundle elements');

    let inProgress = false;
    const isDuo = () => duoInput.checked;
    const selected = (select) => select.options[select.selectedIndex];

    const updatePrices = () => {
      const currentPrice = +(selected(currentSelect)?.dataset.price || 0);
      const secondPrice = +(selected(secondSelect)?.dataset.price || 0);
      const solo = formatMoney(currentPrice);
      const duo = formatMoney(currentPrice + secondPrice);
      if (solo && soloPriceEl) soloPriceEl.textContent = solo;
      if (duo && duoPriceEl) duoPriceEl.textContent = duo;
    };

    const setThemeSize = (size) => {
      if (!size) return;
      const input = [...scope.querySelectorAll('input[type="radio"][data-index="option1"]')]
        .find(el => el.value === size);
      if (input && !input.checked) input.click();
    };

    const addBundle = () => {
      const current = selected(currentSelect);
      const second = selected(secondSelect);
      if (inProgress || !current || !second || current.disabled || second.disabled) return;

      inProgress = true;
      const props = {
        _accelerated_bundle_id: root.dataset.bundleId,
        _accelerated_bundle_data: JSON.stringify({
          color: root.dataset.color || '',
          image: root.dataset.image || '',
          content: `${root.dataset.title}: ${current.textContent.trim()},${root.dataset.secondTitle}: ${second.textContent.trim()}`.toUpperCase(),
          ids: `${current.value}+${second.value}`
        })
      };

      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: +current.value, quantity: 1, properties: props },
            { id: +second.value, quantity: 1, properties: props }
          ]
        })
      })
        .then(res => {
          if (!res.ok) return res.json().then(err => { throw new Error(err.description || `Cart add failed: ${res.status}`); });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
        })
        .catch(e => console.warn(LOG_PREFIX, 'addBundle', e))
        .finally(() => { inProgress = false; });
    };

    const interceptAtc = (e) => {
      if (!isDuo()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundle();
    };

    form.addEventListener('submit', interceptAtc, true);
    form.querySelector('button[name="add"]')?.addEventListener('click', interceptAtc, true);

    currentSelect.addEventListener('change', () => {
      setThemeSize(selected(currentSelect)?.dataset.size);
      updatePrices();
    });
    secondSelect.addEventListener('change', updatePrices);

    document.addEventListener('variant:change', (e) => {
      const id = e.detail?.variant?.id;
      if (!id || ![...currentSelect.options].some(o => o.value === String(id))) return;
      currentSelect.value = String(id);
      updatePrices();
    });

    updatePrices();
    root.dataset.accReady = '1';
    root.hidden = false;
  };

  const init = () => {
    document.querySelectorAll('[data-acc-bundle]').forEach(root => {
      try {
        setup(root);
      } catch (e) {
        console.warn(LOG_PREFIX, 'Bundle selector stays hidden:', e);
      }
    });
  };

  init();
  // Theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
})();
